import { objectEntries } from '@hrlogics/helper-utils';

import type { ValueOf } from '@clearverify/types';

import { ExcelEmployerRow, TemplateField, templateSchema } from '../constants';
import type { InvitedEmployerData } from '../types';

export const convertDataWithSchema = (rows: ExcelEmployerRow[]): InvitedEmployerData[] => {
  const templateEntries = objectEntries(templateSchema);
  const reversedTemplateEntries = templateEntries.map(entry => [entry[1], entry[0]]);
  const reversedTemplate: Record<
    ValueOf<typeof templateSchema>,
    keyof typeof templateSchema
  > = Object.fromEntries(reversedTemplateEntries);

  return rows.map(row => {
    const rawEntries = objectEntries(row);
    const entries = rawEntries.map(entry => {
      const newKey = reversedTemplate[entry[0]];
      let newValue: string | number = entry[1];

      if (newKey === TemplateField.numberOfEmployees) {
        newValue = Number(newValue);
      } else {
        newValue = newValue.trim();
      }

      return [newKey, newValue];
    });

    return Object.fromEntries(entries);
  });
};
